<template>
  <b-card no-body class="transaction-item" tag="article">
    <b-card-body>
      <router-link class="transaction-item__img" :to="to">
        <b-img-lazy fluid v-bind="imgProps" :src="toolImage"></b-img-lazy>
      </router-link>
    </b-card-body>
    <div class="transaction-item__tool">
      <span>{{ transactionDate }}</span>
      <p>{{ tool.name | tooLong(70) }}</p>
      <b-card-title title-tag="h3" class="d-flex align-items-center"
        >${{ tool.price | price }}
        <p>/per day</p></b-card-title
      >
    </div>
    <div class="card-divider"></div>
    <div class="transaction-item__owner d-flex align-items-center">
      <div class="d-flex align-items-center">
        <b-avatar :src="userAvatar" size="30px" class="mr-2"></b-avatar>
        <h6>{{ userName | tooLong(80) }}</h6>
      </div>
      <div class="owner-number d-flex flex-row align-items-center">
        <b-img :src="require('@/assets/icons/telephone.svg')"> </b-img>
        <p>{{ userNumber }}</p>
      </div>
    </div>
  </b-card>
</template>
<script>
/**
 * ==================================================================================
 * Transaction Item card
 * ==================================================================================
 **/

import dayjs from 'dayjs'
import Transaction from '@/models/Transaction'

export default {
  props: {
    transaction: {
      type: [Transaction, Object],
      required: true
    }
  },
  computed: {
    transactionDate() {
      if (!this.transaction.from || !this.transaction.to) return 'NA'

      let start = dayjs(this.transaction.from)
      let end = dayjs(this.transaction.to)

      return (
        start.format(start.year() === end.year() ? 'DD MMMM' : 'DD MMMM YYYY') +
        ' - ' +
        end.format('DD MMMM YYYY')
      )
    },

    user() {
      return this.transaction.is_tool_owner
        ? this.transaction.renter_details
        : this.transaction.tool.owner
    },

    userName() {
      return this.user ? this.user.full_name : ''
    },

    userNumber() {
      return this.user ? this.user.phone_number : ''
    },

    userAvatar() {
      return this.user ? this.user.avatar_permanent_thumb_url : ''
    },

    tool() {
      return this.transaction.details
    },

    toolImages() {
      return this.transaction.tool ? this.transaction.tool.image : []
    },

    toolImage() {
      if (!this.toolImages)
        return require('@/assets/images/img-placeholder.svg')
      return (
        this.toolImages.thumb_url ||
        this.toolImages.permanent_url ||
        this.toolImages.url
      )
    },

    to() {
      return {
        name: 'transaction.view-transaction-page',
        params: {
          id: this.transaction.renter_code
        }
      }
    }
  },
  data() {
    return {
      imgProps: {
        center: true,
        blank: true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.transaction-item {
  display: flex;
  min-width: 300px;
  border: 1px solid #f4f5f6;
  box-shadow: 0px 6px 12px #00000008;

  p {
    font-size: 0.95rem;
    font-weight: 400;
  }

  .card-body {
    padding-bottom: 10px;
  }

  .card-divider {
    padding-bottom: 15px;
    margin: 0 1.25rem;
    border-top: 1px solid #dedede;
  }

  &__img {
    display: flex;
    height: 200px;

    > img {
      width: 100%;
      border: 1px solid #b5b5b5;
      border-radius: 4px;
    }
  }

  &__tool,
  &__owner {
    padding: 0 1.25rem;
  }

  &__tool {
    padding-bottom: 15px;

    > * {
      display: block;
      margin-bottom: 0;
      padding-bottom: 7px;
    }

    span {
      font-size: 0.8rem;
    }

    h3 {
      p {
        margin-left: 10px;
        margin-bottom: 0;
      }
    }
  }

  &__owner {
    justify-content: space-between;
    padding-bottom: 1rem;

    h6 {
      font-weight: 600;
      margin-bottom: 0;
    }

    .owner-number {
      img {
        width: 12.5px;
        margin-right: 5px;
      }

      p {
        margin-bottom: 0;
      }
    }
  }
}
</style>
